import React from 'react';
import { Redirect, withRouter } from 'react-router';

let BackButton = ({ ...props }) => {

    let innerText = props.innerText;

    let goBack = (event) => {
        event.preventDefault();
        props.history.goBack();
    } 

    return (
        <button className={props.className ? props.className : ""} type="button" onClick={goBack} >{innerText}</button>
    )
}

export default withRouter(BackButton);